import { del, get, set } from "idb-keyval";
import type { SceneObjectData, SceneSettings } from "../types";

const SCENE_KEY = "formwerk:scene";

interface PersistedScene {
  objects: SceneObjectData[];
  settings: SceneSettings;
  savedAt: number;
}

export async function saveSceneToIndexedDb(objects: SceneObjectData[], settings: SceneSettings) {
  const payload: PersistedScene = { objects, settings, savedAt: Date.now() };
  await set(SCENE_KEY, payload);
}

export async function loadSceneFromIndexedDb(): Promise<PersistedScene | undefined> {
  return get<PersistedScene>(SCENE_KEY);
}

export async function clearSceneFromIndexedDb() {
  await del(SCENE_KEY);
}
